// extracted by mini-css-extract-plugin
export default {"remove":"removableTag_remove__eP3oCM3z","removeIcon":"removableTag_removeIcon__s5L5K-Ql"};